export default function(el) {
    const showdiv = document.querySelector(el);
    document.addEventListener('scroll', () => {
        if(window.pageYOffset > 700) {
            showdiv.classList.add('scrolled');
        } else {
            showdiv.classList.remove('scrolled');
        }
    });
}